<template>
  <div class="login-gate">
    <span class="login-gate__badge">
      <vb-icon
        name="lock_v2"
        color="ffffff"
        :size="28"
      />
    </span>

    <h2 class="login-gate__title">Accedi per acquistare</h2>

    <p class="login-gate__text">
      L'acquisto di Gift Card è riservato agli utenti autenticati tramite portale
      welfare aziendale. Accedi con il tuo account per sbloccare il catalogo.
    </p>

    <!-- card di sola vetrina: nessun importo scelto, il taglio si sceglie da dentro -->
    <gift-card
      class="login-gate__card"
      variant="primary"
      :logo_src="product.logo_white"
      :category="product.category"
      :validity="validity"
    >
      <gift-card-value />
    </gift-card>

    <p class="login-gate__note">
      Autenticazione sicura SSO · I tuoi dati sono protetti
    </p>
  </div>
</template>

<script>
  import { product_contents, VALIDITY_LABEL } from '@livegift/resources';
  import GiftCardValue from '@livegift/components/blocks/gift-card/gift-card-value.vue';

  // la card in vetrina è sempre questa: al visitatore serve un esempio di che
  // cosa comprerà, non una scelta fra i prodotti
  const SAMPLE_PRODUCT_CODE = 'gc-vadobay-live';

  export default {
    name: 'login-gate',

    components: {
      'gift-card-value': GiftCardValue,
    },

    computed: {
      // logo bianco e categoria dalla copy locale: senza sessione il catalogo
      // non viene chiesto, quindi lo store non ha prodotti
      product: () => product_contents(SAMPLE_PRODUCT_CODE),

      validity: () => VALIDITY_LABEL,
    },
  };
</script>

<style lang="scss" scoped>

  .login-gate {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: $grid-gutter-width;
    border-radius: $border-radius-lg * 6;
    background-image: linear-gradient(128deg, $primary 5%, $black 100%);
    box-shadow: 0 25px 50px -12px rgba($black, .25);
    text-align: center;

    @include media-breakpoint-up(xl) {
      margin: 0 100px;
    }

    &__badge {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      margin-bottom: $grid-gutter-width * .8;
      border: 1px solid rgba($white, .2);
      border-radius: $border-radius-lg * 3;
      background-color: rgba($white, .1);
      backdrop-filter: blur(8px);
      box-shadow: 0 10px 15px rgba($black, .1), 0 4px 6px rgba($black, .1);
    }

    &__title {
      margin-bottom: $grid-gutter-width / 4;
      font-size: $font-size-base * 1.5;
      font-weight: $vb-font-weight-bold;
      color: $white;
    }

    &__text {
      max-width: 384px;
      margin-bottom: $grid-gutter-width;
      color: rgba($white, .8);
    }

    // la card resta quella del resto del portale: nel Figma di questo blocco ha
    // la testata impilata, ma quel disegno è più vecchio del componente
    &__card {
      max-width: 520px;
      margin-bottom: $grid-gutter-width;
      text-align: left;
    }

    &__note {
      margin: 0;
      font-size: $font-size-sm;
      color: rgba($white, .6);
    }

    ::v-deep {
      .gift-card__footer {
        display: none;

        @include media-breakpoint-up(sm) {
         display: flex;
        }
      }
    }
  }
</style>
